import React, {useEffect} from 'react';
import ReportUtils from "../../../../../utils/report-utils.js";
import occurrenceService from "../../../../../services/web/occurrence-service.js";
import {toast} from "react-toastify";

const ReportContent = ({data, tableColumns}) => {

    useEffect(() => {
        ReportUtils.createExportableTable(null, null, `Qualidade da informação`, "information-quality");
    }, [data, tableColumns]);

    const findProblem = (item) => {
        const local = JSON.parse(item.local);

        let problems = '';

        if (item.description === '' || !item.description) {
            problems = 'Sem descrição';
        }

        if (!item.system_dt_ini || !item.system_dt_end) {
            problems += (problems.length > 0 ? ', ' : '') + ' D/H fato incompleta';
        }

        if (local) {
            if (local.city === '' || !local.city) {
                problems += (problems.length > 0 ? ', sem' : 'Sem') + ' município';
            }

            if (local.address === '' || !local.address) {
                problems += (problems.length > 0 ? ', sem' : 'Sem') + ' logradouro';
            }

            if (local.neighborhood === '' || !local.neighborhood) {
                problems += (problems.length > 0 ? ', sem' : 'Sem') + ' bairro';
            }
        } else {
            problems += (problems.length > 0 ? ', sem' : 'Sem') + ' município, sem logradouro, sem bairro';
        }

        if(problems) item.problems = problems + '.';
        return problems
    }

    const openInSentryView = async (id) => {
        occurrenceService.openSentryViewOccurrence(id).then(() => {
            toast.success(`A ocorrência ${id} será aberta no SentryView`)
        })
          .catch(e => {
              console.error(e)
              toast.error('Não foi possível abrir a ocorrência no SentryView');
          });
    }

    const columns = [
        {id: "id", label: "ID", renderCell: item => <a className="report-link text-[#337ab7]! print:text-[#000]!" onClick={() => openInSentryView(item.id)}>{item.id}</a>},
        {id: "system_dt_create", label: "D/H do cadastro", renderCell: item => item.system_dt_create},
        {id: "problems", label: "Problemas", renderCell: findProblem}
    ];
    const visibleColumns = columns.filter(column => tableColumns?.[column.id]?.visible !== false);

    return (
        <>
            {visibleColumns.length === 0 && <div className="alert alert-info p-2 h6 text-center mt-[20px]!">Todas as colunas foram ocultadas.</div>}
            <table id="information-quality" className={`table report-table ${visibleColumns.length === 0 ? "hidden" : ""}`} sheet-name="Qualidade da informação">
                <thead className="thead-background print:table-row-group!">
                    <tr className="bg-[#f6f6f6] text-left">
                        {visibleColumns.map(column => <th key={column.id}>{tableColumns?.[column.id]?.label ?? column.label}</th>)}
                    </tr>
                </thead>
                <tbody className="bg-white">
                    {data.length > 0 && data.map((item, idx) => (
                        <tr key={idx} className="table-break-word">
                            {visibleColumns.map(column => <td key={column.id}>{column.renderCell(item)}</td>)}
                        </tr>
                    ))}
                </tbody>
            </table>

            <div id="chart-tables"/>
        </>
    );
};

export default ReportContent;